import Swiper, { Autoplay, Pagination, Thumbs } from 'swiper'; 
Swiper.use([Thumbs, Pagination, Autoplay]);

export default class swiperSlider {
    constructor(el) {
        if (!this.set(el)) return;
        this.init(); 
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.slider = this.root.querySelector('[data-brands-slider-swiper]');
        this.pagination = this.root.querySelector('[data-brands-slider-pagination]');
        this.swiper = null;

        return true;
    }

    init() {
        this.swiper = new Swiper(this.slider, {
            slidesPerView: 2,
            spaceBetween: 16,
            centeredSlides: true,
            //autoplay: {
            //    delay: 2000,
            //},
            pagination: {
                el: this.pagination,
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`;
                },
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    loop: false,
                    centeredSlides: true,
                    spaceBetween: 0,
                }
            }
        });
    }
}